<div *ngIf="showLoading" class="reward-detail-loading" aria-live="polite" aria-busy="true" role="alert" tabindex="2">
    <div class="loading-spinner">
        <div class="large progress" alt="Loading..." aria-label="Loading...">
            <div class="prog1">
                <div class="prog2"></div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="!showLoading">
    <div id="promotion-Info" [innerHTML]="promotionHeroDataObj | safeHtml">
    </div>
    <app-promotion-code [isWebView]="isWebView" [partnerDetails]="partnerDetails" (partnerRedeemObject)="getPartnerRedeemObject($event)"></app-promotion-code>
</div>
